import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { accountTreeModel } from 'entities/account/model';
import { MultiSelect } from 'shared/ui';
import cls from './account-tree-currencies.module.scss';

export const AccountTreeCurrencies = () => {
	const { t } = useTranslation();

	const [currencies, value, change] = useUnit([
		accountTreeModel.$currencies,
		accountTreeModel.currenciesField.$value,
		accountTreeModel.currenciesField.change,
	]);

	if (currencies.length <= 1) return null;

	return (
		<MultiSelect
			searchable
			id='account-tree-currencies'
			data={[...currencies]}
			value={value}
			className={cls.accountTreeCurrencies}
			label={t('account-tree.currencies')}
			placeholder={t('account-tree.all')}
			onChange={change}
		/>
	);
};
